import * as Sentry from '@sentry/vue';
import dayjs from 'dayjs';

import { watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

import { UserInfo } from '@future-harry/nxt-styles';
import { storeToRefs } from 'pinia';
import { useUserInfoStore } from '../collections/user-info/user-info.store';
import { clearAllCache } from '../helpers/cache.helper';

export function useApp() {
   const { t } = useI18n();
   const route = useRoute();
   const router = useRouter();
   const { locale } = useI18n();

   //#region Global Data
   const userInfoStore = useUserInfoStore();
   const { userInfo, loadingUserInfo } = storeToRefs(userInfoStore);

   watch(userInfo, fetchGlobalData, { immediate: true });

   async function fetchGlobalData(userInfo?: UserInfo) {
      if (!userInfo) return;

      try {
         Promise.allSettled([]);
      } catch (ex) {
         Sentry.captureException(ex);
         router.push({
            path: '/error',
            query: {
               error_code: '400',
               error_title: t('errors.error'),
               error_message: t('errors.unknown-error'),
               error_action: 'refresh',
            },
         });
      }
   }

   //#endregion

   //#region User Info
   function handleLocaleChange(newLocale: string) {
      if (newLocale) {
         dayjs.locale(newLocale);
         document.documentElement.lang = newLocale.toLowerCase();
         if (route.meta.titleKey) {
            document.title = `${t('app-name')} - ${t(route.meta.titleKey as string)}`;
         }
      }
   }

   async function handleUserChange(userInfo?: UserInfo, oldUserInfo?: UserInfo) {
      if (userInfo) {
         Sentry.setUser({ username: `${userInfo.first_name} ${userInfo.last_name}`, email: userInfo.email, id: userInfo.id.toString() });
         if (oldUserInfo && userInfo?.id !== oldUserInfo.id) {
            clearAllCache();
            window.location.reload();
         }

         locale.value = userInfo?.language?.iso_639_1?.toLowerCase() || 'nl';
         dayjs.locale(locale.value);
         dayjs.updateLocale(locale.value, { weekStart: 1 });
      } else {
         Sentry.setUser(null);
      }
   }
   //#endregion

   return { handleLocaleChange, handleUserChange, loading: loadingUserInfo };
}
